import { getAuth } from "firebase/auth";
import { collection, doc, getDocs, query, updateDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { db } from "../../firebase";
import { Listbox } from "@headlessui/react";

function Transaction() {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const auth = getAuth();
    const user = auth.currentUser;

    useEffect(() => {
        const fetchPayments = async () => {
          if (user) {
            const q = query(
              collection(db, "payments")
            );
            const querySnapshot = await getDocs(q);
            const paymentsData = querySnapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));
            setTransactions(paymentsData);
            setLoading(false);
          }
        };
    
        fetchPayments();
      }, [user]);

      const formatDate = (seconds) => {
        const date = new Date(seconds * 1000);
        const options = { day: "numeric", month: "long", year: "numeric" };
        const dateString = date.toLocaleDateString("fr-FR", options);
        const timeString = date.toLocaleTimeString("fr-FR", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${dateString} à ${timeString}`;
      };

      const handleUpdateStatus = async (id, newStatus) => {
        try {
          const transactionRef = doc(db, "payments", id);
          await updateDoc(transactionRef, { status: newStatus });
          // Mise à jour locale de l'état
          setTransactions((prevTransactions) =>
            prevTransactions.map((transaction) =>
              transaction.id === id ? { ...transaction, status: newStatus } : transaction
            )
          );
        } catch (error) {
          console.error("Erreur lors de la mise à jour de l'état de la transaction :", error);
        }
      };
    
      const formatHeure = (seconds) => {
        const date = new Date(seconds * 1000);
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        return `${hours}:${minutes}`;
      };
    
      const formatSimpleDate = (seconds) => {
        const date = new Date(seconds * 1000);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };
  return (
    <div className='h-screen'>
      <Helmet>
        <title>Transactions</title>
      </Helmet>
      <h1 className="poppins-bold text-3xl md:text-5xl text-gray-900 text-center">
        Toutes transactions
      </h1>
      <section class="relative mt-5">
        <div class="w-full max-w-7xl px-3 lg-6 space-y-2 mx-auto">
          <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
            <div className="overflow-x-auto">
              <table className="table">
                {/* head */}
                <thead className="text-gray-800 text-sm uppercase poppins-semibold">
                  <tr>
                    <th className="text-nowrap">N° fact</th>
                    <th className="text-nowrap">Client</th>
                    <th className="text-nowrap">Montant</th>
                    <th className="text-nowrap">Paiement</th>
                    <th className="text-nowrap">Status</th>
                    <th className="text-nowrap">Date</th>
                    <th className="text-nowrap">Action</th>
                  </tr>
                </thead>
                <tbody>
                {loading ? (
                  <tr className="bg-white border-b hover:bg-gray-50">
                    <td
                      colSpan={7}
                      className="text-center py-3 poppins-semibold uppercase"
                    >
                      <span className="loading loading-spinner loading-lg"></span>
                    </td>
                  </tr>
                ) : transactions.length === 0 ? (
                  <tr className="bg-white border-b hover:bg-gray-50">
                    <td
                      colSpan={7}
                      className="text-center py-3 poppins-semibold uppercase"
                    >
                      Aucune transactions enregistré
                    </td>
                  </tr>
                ) : (
                transactions.map((transaction, index) => (
                  <tr key={transaction.id} className="text-gray-600">
                    <td className="poppins-semibold text-pink-600 text-nowrap">ECO-{transaction.num_facture}</td>
                    <td className="text-nowrap">{transaction.fullName_ship}</td>
                    <td className="uppercase text-nowrap">{(transaction.amount / 100).toFixed(2)} {transaction.currency}</td>
                    <td>{transaction.payment_method}</td>
                    <td>
                    {transaction.status === "succeeded" ? (
                            <div className="badge badge-success text-white text-xs text-nowrap w-full">
                              Complété
                            </div>
                          ) : transaction.status === "pending" ? (
                            <div className="badge badge-warning text-white text-xs text-nowrap w-full">
                              En attente
                            </div>
                          ) : (
                            <div className="badge badge-error text-white text-xs text-nowrap w-full">
                              Réfusé
                            </div>
                          )}
                      </td>
                    <td>{formatDate(transaction.createdAt.seconds)}</td>
                    <td className="px-3">
                    <Listbox
                      value={transaction.status}
                      onChange={(newStatus) =>
                        handleUpdateStatus(transaction.id, newStatus)
                      }
                    >
                      <div className="relative mt-1">
                        <Listbox.Button
                          disabled={transaction.status === "succeeded"}
                          className={`relative w-full rounded-lg py-2 pl-3 pr-10 text-left shadow-md focus:outline-none sm:text-sm text-nowrap ${
                            transaction.status === "succeeded" ? "opacity-60 cursor-not-allowed bg-green-100 text-green-900 poppins-semibold" : transaction.status === "failed" ? "opacity-60 cursor-not-allowed bg-red-100 text-red-900 poppins-semibold" : "bg-amber-100 text-amber-800 poppins-semibold"
                          }`}
                        >
                          {transaction.status === "succeeded" ? (
                            <span className="block truncate">
                            Complété
                          </span>
                          ) : transaction.status === "pending" ? (
                            <span className="block truncate">
                            En attente
                          </span>
                          ) : (
                            <span className="block truncate">
                            Réfusé
                          </span>
                          )}
                        </Listbox.Button>
                        <Listbox.Options className="absolute z-40 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                          {["succeeded", "pending", "failed"].map((status) => (
                            <Listbox.Option
                              key={status}
                              className={({ active }) =>
                                `relative cursor-pointer select-none py-2 pl-10 pr-4 ${
                                  active ? "bg-pink-100 text-pink-800" : "text-gray-900"
                                }`
                              }
                              value={status}
                            >
                              {({ selected }) => (
                                <>
                                  <span
                                    className={`block truncate ${
                                      selected ? "font-medium" : "font-normal"
                                    }`}
                                  >
                                    {status}
                                  </span>
                                </>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </div>
                    </Listbox>
                    </td>
                  </tr>
                  ))
                )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Transaction;
